import { useCallback } from 'react';
import { toast } from 'react-hot-toast';
import { useLanguage } from '@/state/language/LanguageProvider';

/** Shared autosave failure feedback for template builder panels. */
export function useTemplateSaveError(): (error: unknown) => void {
  const { t } = useLanguage();
  return useCallback(
    (error: unknown) => {
      console.error('Template autosave failed', error);
      toast.error(t('assessmentEngine.templates.actionFailed'));
    },
    [t]
  );
}
